import { Link, useLocation } from 'react-router-dom';
import { breadcrumbTrail, CAREERS_PATH } from '../config/seoShared';

// Visible breadcrumb trail under the navbar. The matching BreadcrumbList structured
// data comes from PageSEO, so what search engines read is what visitors see.
export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const isJob = path.startsWith(`${CAREERS_PATH}/`);
  const trail = breadcrumbTrail(path, isJob ? `Job ${path.split('/')[2]}` : undefined);
  if (trail.length < 2) return null;

  return (
    <nav aria-label="Breadcrumb" style={{ background: 'var(--dark)' }}>
      <ol
        className="container"
        style={{
          listStyle: 'none',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 6,
          margin: '0 auto',
          padding: '10px 24px 0',
          fontSize: 12,
          color: 'rgba(255,255,255,0.55)',
        }}
      >
        {trail.map((item, i) => {
          const last = i === trail.length - 1;
          return (
            <li key={item.path} style={{ display: 'flex', gap: 6 }}>
              {last ? (
                <span aria-current="page" style={{ color: 'rgba(255,255,255,0.85)' }}>
                  {item.name}
                </span>
              ) : (
                <>
                  <Link to={item.path} style={{ color: '#00AEEF', textDecoration: 'none' }}>
                    {item.name}
                  </Link>
                  <span aria-hidden="true">/</span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
